export default __webpack_public_path__ + "static/media/banner-bg-apps.aae5116c.png";